<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<div class="chat-product-card">
	<button
		on:click={() => handleClickProduct(product.url, product.name, product)}
		aria-label={`View details for ${product.name}`}
		class="product-image-container"
	>
		<img
			src={currentSrc}
			alt={product.name}
			class="product-image"
			on:error={handleImageError}
			loading="lazy"
		/>
	</button>
	<div class="product-info">
		<div>
			<button
				class="product-name"
				on:click={() => handleClickProduct(product.url, product.name, product)}
				aria-label={`View details for ${product.name}`}
			>
				{@html product.name}
			</button>

			{#if product.options > 1}
				<div class="option-available-label">{product.options} options available</div>
			{/if}
		</div>

		<div class="price-container">
			<div class="starting-price-label">starting at</div>
			<div class="product-price">
				{#if product?.options <= 1}
					{product?.prices?.highest}
				{:else if product?.prices?.salePrice !== product?.prices?.retailPrice}
					<span class="retail-price">{product.prices?.retailPrice}</span>
					<span class="sale-price">{product.prices?.salePrice}</span>
				{:else}
					{product?.prices?.retailPrice}
				{/if}
			</div>

			{#if product?.prices?.chargeMessage}
				<div class="charge-message">{product?.prices.chargeMessage}</div>
			{/if}
		</div>
		{#if product?.recommendationReason}
			<div class="recommended">
				<img class="recommended-icon" src="floraIconUpdate.svg" alt="Floralogo" />
				<div class="recommended-label">{product.recommendationReason}</div>
			</div>
		{/if}
	</div>
</div>

<script lang="ts">
	import type { ProductObject } from '$lib/apis/webchat/type';
	export let product: ProductObject;
	export let handleClickProduct: (
		url: string,
		productName: string,
		selectedProduct: ProductObject
	) => void;
	let fallbackSrc =
		'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc881f4b32ef5f484/60dcd2de4b10c259bbae6426/Image_Not_Available.png';
	let currentSrc = product?.image || fallbackSrc;

	function handleImageError() {
		if (currentSrc !== fallbackSrc) {
			currentSrc = fallbackSrc;
		}
	}
</script>

<style>
	button {
		all: unset;
		cursor: pointer;
	}

	.chat-product-card {
		display: flex;
		flex-direction: column;
		border: 1px solid #d9d9d9;
		border-radius: 3px;
		overflow: hidden;
	}

	.product-image-container {
		display: flex;
		align-items: stretch;
		height: 176px;
		cursor: pointer;
	}
	.product-image-container img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.product-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding: 8px 12px 12px 12px;
		gap: 8px;
	}

	.product-name {
		font-size: 14px;
		line-height: 19px;
		color: #333;
		margin: 8px 0;
		text-decoration: none;
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 400;
		letter-spacing: 0;
		cursor: pointer;
	}

	.option-available-label {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 400;
		font-size: 12px;
		line-height: 17px;
		letter-spacing: 0;
		color: #555555;
	}

	.starting-price-label {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 400;
		font-size: 12px;
		line-height: 17px;
		letter-spacing: 0%;
	}

	.product-price {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 700;
		font-size: 18px;
		line-height: 23px;
		letter-spacing: 0%;
	}

	.recommended {
		display: flex;
		gap: 6px;
	}

	.recommended-icon {
		width: 16px;
		height: 16px;
	}

	.recommended-label {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 400;
		font-size: 12px;
		line-height: 17px;
		letter-spacing: 1%;
	}
	.retail-price {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 400;
		font-size: 18px;
		line-height: 23px;
		letter-spacing: 0%;
		text-decoration: line-through;
	}
	.sale-price {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 700;
		font-size: 18px;
		line-height: 23px;
		letter-spacing: 1%;
		color: #a1001a;
	}
	.charge-message {
		font-size: 12px;
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
	}
</style>
